import styled from 'styled-components';

import {Device} from '../../../../constants';

const CrewSectionContainer = styled.section`
  display: flex;
  width: 100%;
  height: 80vh;
  min-height: 800px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  z-index: 1;
  clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 10%);
  margin-top: -50px;

  @media screen and ${Device.laptop} {
    height: 100%;
    min-height: 100%;
    flex-direction: column-reverse;
    margin-top: 0;
  }

  @media only screen and ${Device.mobileL} {
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 5%);
  }
`;

export default CrewSectionContainer;
